"use client";

import { useClass } from "@knowt/syncing/hooks/classes/useClass";
import br from "@/styles/breakpoints.module.css";
import Breadcrumb from "@/components/Breadcrumb";

const SetOverviewCourseBreadcrumb = ({ classId }: { classId: string }) => {
    const { course } = useClass({ classId });

    return (
        <Breadcrumb
            className={br.mdDownFullWidthScrollableX}
            root="home"
            items={[
                {
                    label: course?.name || "",
                    href: `/class/${course?.classId}/dashboard`,
                    img: `/images/class-icon.svg`,
                },
            ]}
        />
    );
};

export default SetOverviewCourseBreadcrumb;
